import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from '../decorators';
import { GetUserInfo } from 'domain/usecases/get-user-info';
import { RemoteGetUserInfo } from 'data/usecases/remote-get-user-info';

export const makeRemoteGetUserInfo = (): GetUserInfo => {
  return new RemoteGetUserInfo(makeApiUrl('/getUserInfo'), makeAuthorizeHttpClientDecorator());
};
